import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Title, Button, Text } from 'ui';
import { useAuth, sendEmailVerification } from 'api';
import logo from '../assets/logo-white.png'

export default function VerifyEmail(props) {

  const auth = useAuth();
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");

  if(!auth) {
    return null;
  }

  if(auth.emailVerified) {
    return <Redirect to="/"/>;
  }

  async function resend() {
    setStatus("");
    setError("");
    try {
      await sendEmailVerification(auth.email);
      setStatus("Verification email sent.");
    }
    catch(error) {
      setError(error.message);
    }
  }

  return (
    <div className="auth auth-login">
      <div className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">Check your email</Title>
        <div style={{paddingBottom:16}}>
          <Text white>We’ve sent a message to {auth.email} with a link to activate your account.</Text>
        </div>
        <div style={{paddingBottom:16}}>
          <Text white>
            If you don’t see an email from us within a few minutes, try <Button orange tertiary onClick={resend}>resending the email.</Button>
          </Text>
        </div>
        <div>
          <Text white bold>{status}</Text>
        </div>
        <div>
          <Text color="red">{error}</Text>
        </div>
      </div>
    </div>
  );
}